import React from 'react';
import { FundItem } from '../../../../models/Fund';
import ContentBox from '../../../common/ContentBox';
import FundAllocationBubbles from '../../../common/FundAllocationBubbles';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SectorDistribution } from '../../../../models/Common';

export interface IOverviewSectorDistributionProps {
    fund: FundItem;
}

const OverviewSectorDistribution: React.FC<IOverviewSectorDistributionProps> = ({ fund }) => {
    const { t } = useTranslation();
    return <ContentBox proportion={1}>
        <Box display={"flex"} flexDirection={"column"}>
            <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('LibraryOfFundsOverviewTabSectorTitle')}</Typography>
            <FundAllocationBubbles values={fund.sectorDistribution as SectorDistribution[]} />
        </Box>
    </ContentBox>
}

export default OverviewSectorDistribution;